import IconButton from '@components/IconButton';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ControlIcon from '@icons/Control';
import { useFlow } from '@stackflow/react';
import { useAtomValue } from 'jotai';

import { couponSortsAtom, CouponSortTab } from '../../atoms/couponAtoms';

interface Props {
    tab: CouponSortTab;
}

/** 정렬 바텀시트를 여는 버튼. 기본 정렬(등록순)이 아니면 점으로 표시한다. */
function CouponFilter({ tab }: Props) {
    const { push } = useFlow();
    const sort = useAtomValue(couponSortsAtom)[tab];
    return (
        <Wrapper>
            <IconButton
                dot={sort !== 'registered'}
                onClick={() => push('CouponSortBottomSheet', { tab })}>
                <ControlIcon color={colors.gray7} size={24}/>
            </IconButton>
        </Wrapper>
    );
}

// IconButton 컨테이너가 block 이라 점 위치가 버튼 기준이 되도록 폭을 내용에 맞춘다.
const Wrapper = styled.div`
    padding: var(--spacing-4);
    width: fit-content;
`;

export default CouponFilter;
